<template>
    <div class="box">
        <!-- <inner-table id="innerExam" ref="examList" :listviewurl="'student.examScores.listStudent'" :can-edit="canEdit" :exclude-fields="'column_operate'" :can-delete="canEdit" :link-prop-name="'studentId'" />
          -->
        <!-- <div style="background-color: #ccc;">
            <h5>111</h5>
        </div> -->
        <table v-if="tableData.length > 0" border="0" class="el-table__body">
            <tbody v-for="(item, index) in tableData" :key="index">
                <tr>
                    <td colspan="23" style="vertical-align: middle; background-color: rgba(242, 245, 251); color: rgba(62, 86, 105)">{{ item.name }}</td>
                </tr>
                <tr>
                    <td colspan="1" style="text-align: center; vertical-align: middle">序号</td>
                    <td colspan="20" style="vertical-align: middle">科目</td>
                    <td colspan="2" style="text-align: center; vertical-align: middle">成绩</td>
                </tr>
                <tr v-for="(item1, index1) in item.list" :key="index1">
                    <td colspan="1" style="text-align: center; vertical-align: middle">{{ index1 + 1 }}</td>
                    <td colspan="20" style="vertical-align: middle">{{ item1.courseName }}</td>
                    <td colspan="2" style="text-align: center; vertical-align: middle">{{ item1.score }}</td>
                </tr>
            </tbody>
        </table>
        <table v-else border="0" class="el-table__body">
            <tbody>
                <tr>
                    <td colspan="1" style="text-align: center; vertical-align: middle">序号</td>
                    <td colspan="20" style="vertical-align: middle">科目</td>
                    <td colspan="2" style="text-align: center; vertical-align: middle">成绩</td>
                </tr>
                <tr>
                    <td colspan="23" style="text-align: center; color: #909399">暂无数据</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created: function () {},
    mounted: function () {
        this.getList()
    },
    methods: {
        getList() {
            this.$http({
                method: 'post',
                url: '/xsgl/studentExamScores/listdata?urlsearch=studentId:' + this.vo.studentId
            }).then((res) => {
                if (res.code === 'success') {
                    res.body.pageInfo.list.forEach((a) => {
                        let name = a.schoolYear + '学年' + '第' + a.semester + '学期'
                        if (this.tableData.length == 0) {
                            this.tableData.push({ name: name, list: [] })
                        } else {
                            if (this.tableData.every((a) => a.name != name)) {
                                this.tableData.push({ name: name, list: [] })
                            }
                        }
                    })
                    res.body.pageInfo.list.forEach((a) => {
                        let name = a.schoolYear + '学年' + '第' + a.semester + '学期'
                        this.tableData.forEach((b) => {
                            if (b.name == name) {
                                b.list.push(a)
                            }
                        })
                    })
                }
            })
        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        },
        // 内嵌子表-子表单打开前回调
        onInnerFormBeforeOpen($scope, vo, defer) {
            defer.resolve(true)
        },
        onInnerBasicFormBeforeSubmit($scope, vo, defer) {
            if ($scope.moduleInfo.moduleCode === 'examScores') {
                vo.studentId = this.vo.studentId
            }
            defer.resolve(true)
        }
    }
}
</script>

<style scoped>
.header {
    padding: 10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
    border: 1px solid #999;
}
table {
    border-collapse: collapse; /* 合并边框 */
    width: 100%;
}
table,
th,
td {
    border: 1px solid black; /* 设置边框 */
}
</style>
